import * as React from 'react';
import styles from './index.less';
import { FI18n } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';

export interface FPodcastRssImportingPanelProps {
  className?: string;
  style?: React.CSSProperties;
}

/** 首次导入未完成时的大卡片占位（fullImportCompleted === false） */
function FPodcastRssImportingPanel({ className = '', style }: FPodcastRssImportingPanelProps) {
  return (
    <div className={[styles.panel, className].join(' ')} style={style}>
      <FComponentsLib.FContentText
        text={
          // 单品资源管理
          FI18n.i18nNext.t('cqr_itemmgmt')
        }
        type={'highlight'}
      />
      <div className={styles.body}>
        <div className={styles.title}>正在导入您的播客信息</div>
        <div className={styles.subtitle}>
          可能需要一些时间。处理完成后，您可以回到这里完成发布。
        </div>
      </div>
    </div>
  );
}

export default FPodcastRssImportingPanel;
